import { isClient } from './device-utils';
/**
 * Utility function to check if the current environment is Percy.
 * @returns
 */
export const isPercy = (): boolean | string => {
  if (isClient()) {
    const hasHostname = typeof window === 'object' && window.location && window.location.hostname;
    return hasHostname && /proxyme\.percy\.io|render\.percy\.local/.test(window.location.hostname);
  }
  return false;
};
